import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../../../redux/connect';
import {
  getDocumentCollection,
  getDocumentVersion,
} from '../../../../../redux/selectors';
import { documentCollectionType, issueAttributesType } from '../../../../../constants/proptype-validation';
import cx from 'classnames';
import T from 'i18n-react';
import { toUtcLongDate, isLate } from '../../../../../utils/date-helpers';
import StatusPill from '../../../../../components/StatusPill';

import { SvgIcon } from '@adsk/bim360-matrix-react-components';
import { isPushpinVisible } from '../../../../../utils/issues-helpers';
import hiddenIcon from '../../../../../assets/images/icons/icon-eye-strikethrough.svg';

export class PureIssueSummary extends PureComponent {
  renderVisibilityIndicator() {
    if (!isPushpinVisible(this.props.issue)) {
      return (
        <SvgIcon className="IssueSummary__visibility-icon" width="20px" height="20px">
          {hiddenIcon}
        </SvgIcon>
      );
    }

    return null;
  }

  render() {
    const { issue, onRFIClick } = this.props;
    const { id, customIdentifier, status, title, dueDate, closedAt, currentAssignee, startingVersion, targetUrn } = issue;
    const dueDateClasses = cx('IssueSummary__due-date', {
      'IssueSummary__due-date--overdue': !closedAt && isLate(dueDate),
    });
    const assignToDisplay = currentAssignee || T.translate('assignment.assigneeUnspecified');
    const documentVersion = getDocumentVersion(this.props.documentCollection, targetUrn);

    const isCurrentVersion = startingVersion === documentVersion;
    const currentVersionI18n = isCurrentVersion ? 'version.currentIndicator' : 'version.notCurrentIndicator';
    const documentVersionClasses = cx('IssueSummary__document-version', {
      'IssueSummary__document-version--not-current': !isCurrentVersion,
    });
    const locationValue = issue.locationDescription;

    return (
      <div className="IssueSummary" onClick={() => onRFIClick(id)}>
        {/*Header*/}
        <div className="IssueSummary__header-container">
          <StatusPill status={status} />
          {this.renderVisibilityIndicator()}
          <span className={dueDateClasses}>
            {dueDate ? toUtcLongDate(dueDate) : T.translate('dueDate.unspecified')}
          </span>
        </div>

        {/*Title*/}
        <div className="IssueSummary__title" title={title}>
          {customIdentifier && <span className="IssueSummary__identifier">#{customIdentifier}</span>}
          <span className="IssueSummary__title-text">{customIdentifier ? ` - ${title}` : title}</span>
        </div>

        {/*Assigned to*/}
        <div className="IssueSummary__general-info">
          <span>{T.translate('assignment.to')}: </span>
          <span className="IssueSummary__general-info-ellipsis" title={assignToDisplay}>{assignToDisplay}</span>
        </div>

        {/*Location*/}
        <div className="IssueSummary__general-info">
          <span>{T.translate('issueAttributes.location.label')}: </span>
          <span className="IssueSummary__general-info-ellipsis" title={locationValue}>{locationValue}</span>
        </div>

        {/*Document version*/}
        <div className={documentVersionClasses}>
          <span>{`${T.translate('version.shorthand')}${issue.startingVersion} (${T.translate(currentVersionI18n)})`}</span>
        </div>
      </div>
    );
  }
}

PureIssueSummary.displayName = 'IssueSummary';

PureIssueSummary.propTypes = {
  issue: issueAttributesType.isRequired,
  documentCollection: documentCollectionType,
  onRFIClick: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  documentCollection: getDocumentCollection(state),
});

export default connect(mapStateToProps)(PureIssueSummary);
